import { hasAllowedRole, isLogged } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { type PropsWithChildren, useContext, useEffect } from 'react';
import { Navigate } from 'react-router';
import { baseAction, userAction } from 'store/actions';
import { buildUserState } from 'store/state';

export function User(props: Readonly<PropsWithChildren>) {
	const { config, dispatch, flowType, state } = useContext(AppContext);
	const { context, user } = state;
	const path = globalThis.location.pathname;

	useEffect(() => {
		if (!isLogged(user)) {
			if (user.token) {
				dispatch([userAction, { user: buildUserState() }]);
			}
			if (Object.keys(context).length) {
				dispatch([baseAction, {}]);
			}
		}
	}, [user, context]); // eslint-disable-line react-hooks/exhaustive-deps

	if (config.IS_EMPLOYEE_WEB && !config.BYPASS_ROLE_REQUIREMENT && isLogged(user) && !hasAllowedRole(user.token)) {
		return <p>Access denied. You do not have the required role.</p>;
	}

	if (
		path.endsWith('/curity') ||
		path.endsWith('/authenticate') ||
		path.startsWith('/waiver-confirmation') ||
		isLogged(user)
	) {
		return <>{props.children}</>;
	}

	return <Navigate replace to={`/${flowType}/authenticate`} />;
}
